<script setup>
definePageMeta({
  layout: 'print'
})


const { offer_type_associative } = useAppConfig()
const commercialStore = useCommercialStore()

const { params } = useRoute()
const { id } = params

await commercialStore.getBuildItem(id)

if ( !commercialStore.build_item ) {
    throw createError({
        statusCode: 404,
        statusMessage: 'Page Not Found'
    })
}

const selectViewContainer = ref('map')
const getType = t => {
    return (offer_type_associative[t] !== undefined) ? offer_type_associative[t] : 'помещения'
}

commercialStore.getBuildOffers(id)
const isVisible = computed(() => {
    return (commercialStore.build_offers.items.length > 0) ? true : false
})

useSeoMeta({
    title: "PRINT",
})

</script>

<template>
    <div class="h-full bg-brand-bright">

        <section class="detail py-6">
            <div class="container flex md:gap-6 gap-3.5 flex-col md:flex-row">

                <div class="absolute z-10 flex items-center gap-1 mt-2 ms-28 ps-1">
                    <div v-if="commercialStore.build_item?.build_class"
                        class="flex bg-brand-dark h-[22px] md:h-[26px] p-3 items-center justify-center rounded-md">
                        <p class="text-white text-[14px] md:font-normal p-0 ">Класс {{ capitalize(
                            commercialStore.build_item?.build_class) }}</p>
                    </div>
                </div>

                <div class="flex flex-col items-center w-2/2 md:w-3/5">

                    <OfferGalery v-model="commercialStore.build_item" />

                    <div class="py-6 px-6 bg-white border mt-3 rounded-lg text-brand-grey w-full mt-4">
                        
                        <h1 class="text-dark-800 font-bold text-xl md:text-2xl uppercase">
                            {{ commercialStore.build_item?.name }}
                        </h1>

                        <LayoutsMetro v-model="commercialStore.build_item.metros"
                            v-if="commercialStore.build_item.metros" class="py-2" />

                        <OfferDescription v-model="commercialStore.build_item" />

                        <div class="items-center justify-between pt-5 hidden md:flex">
                            <p class="text-base font-normal bg-gray-100 rounded px-2">№ {{ commercialStore.build_item.id
                                }}</p>
                        </div>

                    </div>

                </div>

                <div class="flex flex-col-reverse md:flex-col w-2/2 md:w-2/5">

                    <div class="items-center justify-between pt-5 flex md:hidden">
                        <span class="text-[13px] font-normal bg-gray-100 rounded px-2">№ {{
                            commercialStore.build_item.id
                            }}</span>
                    </div>

                    <div class="relative h-[500px] md:h-[600px] pt-3 md:pt-0 rounded-lg">

                        <OfferMap v-if="selectViewContainer == 'map'"
                            class="w-full h-full absolute rounded-lg overflow-hidden"
                            v-model="commercialStore.build_item" :header="commercialStore.build_item.name"
                            theme="light" />

                        <OfferPanorama v-if="selectViewContainer == 'panorama'"
                            class="w-full h-full absolute rounded-lg overflow-hidden bg-gray-200"
                            v-model="commercialStore.build_item" />

                        <div class="absolute md:bottom-0 w-full bottom-0 z-10">
                            <button v-if="selectViewContainer == 'map'" @click="selectViewContainer = 'panorama'"
                                class="flex items-center justify-center mb-6 bg-brand-blue text-white py-2 px-3 rounded gap-2 w-fit mx-auto font-medium">
                                <img src="/img/icons/ponarama.svg" alt="" />
                                Панорама
                            </button>
                            <button v-if="selectViewContainer == 'panorama'" @click="selectViewContainer = 'map'"
                                class="flex items-center justify-center mb-6 bg-brand-blue text-white py-2 px-3 rounded gap-2 w-fit mx-auto font-medium">
                                <img src="/img/icons/ponarama.svg" alt="" />
                                Карта
                            </button>
                            <div class="w-full md:h-24 h-[71px] flex items-center gap-6 bg-gray-700 pl-6 rounded-b-lg">
                                <img src="/img/icons/location.svg" class="w-[24px] md:w-[33px]" alt="" />
                                <div>
                                    <h1 v-if="commercialStore.build_item?.region"
                                        class="text-base md:text-xl text-[#E73235] font-bold">
                                        {{ commercialStore.build_item?.region }}
                                    </h1>
                                    <p class="text-base md:text-lg font-normal text-gray-50">
                                        {{ commercialStore.build_item?.ulica + ', ' || '' }}
                                        {{ commercialStore.build_item?.dom || '' }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="flex flex-col md:gap-5 gap-3.5 md:pt-4">

                        <div class="px-6 py-4 bg-white border rounded-lg">

                            <h3 v-if="commercialStore.build_item?.offertype && commercialStore.build_item?.offertype == 'arenda'"
                                class="text-brand-blue font-bold text-base md:text-lg">
                                КОНТАКТЫ
                            </h3>

                            <div class="flex items-center gap-8 pt-3">
                                <div class="flex items-center gap-2 w-1/3">
                                    <img src="/public/img/icons/phone.svg" alt="" />
                                    <p class="font-medium">ТЕЛЕФОН</p>
                                </div>
                                <div class="flex w-2/3 justify-end">
                                    <p class="text-brand-grey truncate w-auto" >
                                        <a href="tel:78129877331" class="text-base">+7 (812) 987-73-31</a>
                                    </p>
                                </div>
                            </div>

                            <div class="flex items-center gap-8 pt-2">
                                <div class="flex items-center gap-2 w-1/3">
                                    <img src="/public/img/icons/email.svg" alt="" />
                                    <p class="font-medium">ЭЛ.ПОЧТА</p>
                                </div>
                                <div class="flex w-2/3 justify-end">
                                    <p class="text-brand-grey truncate w-auto" >
                                        <a href="mailto:info@arendabc.ru" class="text-base">info@arendabc.ru</a>
                                    </p>
                                </div>
                            </div>

                        </div>


                    </div>

                </div>
            </div>
        </section>

    </div>
</template>